if (!customElements.get('yinq-bubbly-personalizer')) {
  customElements.define('yinq-bubbly-personalizer', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-bubbly-name]');
      this.counter = this.querySelector('[data-bubbly-count]');
      this.productInfo = this.closest('product-info');
      this.onInput = () => {
        this.updateValidity();
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.syncLength(), 300);
      };
      this.onChange = () => this.updateValidity();
      this.onSubmit = (event) => {
        if (event.target.id !== this.dataset.formId) return;
        this.input.value = this.input.value.trim().normalize('NFC');
        if (!this.updateValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.input.reportValidity();
          this.input.focus();
          this.syncLength();
        }
      };
      this.input.addEventListener('input', this.onInput);
      this.productInfo?.addEventListener('change', this.onChange);
      this.productInfo?.addEventListener('submit', this.onSubmit, true);
      this.updateValidity();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.input?.removeEventListener('input', this.onInput);
      this.productInfo?.removeEventListener('change', this.onChange);
      this.productInfo?.removeEventListener('submit', this.onSubmit, true);
    }

    getName() {
      const value = this.input.value.trim().normalize('NFC');
      return { value, count: Array.from(value).length, valid: /^\p{L}{1,12}$/u.test(value) };
    }

    updateValidity() {
      const name = this.getName();
      const variant = this.productInfo?.getSelectedVariant(this.productInfo);
      const selectedLength = Number.parseInt(variant?.options?.[1], 10);
      let message = '';
      if (!name.valid) message = this.dataset.invalid;
      else if (selectedLength !== name.count) message = this.dataset.mismatch;
      this.input.setCustomValidity(message);
      this.counter.textContent = this.dataset.counter.replace('__COUNT__', String(name.count));
      return message === '';
    }

    syncLength() {
      const name = this.getName();
      if (!name.valid) return;
      const select = this.productInfo?.querySelector('select[name="options[Namenslänge]"]');
      if (!select) return;
      const option = Array.from(select.options).find((entry) => Number.parseInt(entry.value, 10) === name.count);
      if (option && select.value !== option.value) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.updateValidity();
    }
  });
}

